var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.07 75.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "register_svg__cls-1",
    d: "M72 38.9l-11-11a3.64 3.64 0 00-5.16 0l-2.21 2.21V3.65A3.65 3.65 0 0049.93 0H3.65A3.66 3.66 0 000 3.65v58.46a3.66 3.66 0 003.65 3.65h20.71v6.09A3.64 3.64 0 0028 75.5h11a3.61 3.61 0 002.58-1.07L72 44.07a3.67 3.67 0 000-5.17zM7.31 7.31h39v30.06L25.43 58.22a2.19 2.19 0 00-.21.23H7.31zm30.23 60.88h-5.88v-5.87l26.71-26.71 5.88 5.88z",
    "data-name": "Layer 1"
  }))));
}
export default SvgRegister;